export default theme => ({
  titleSection: {
    marginTop: ({ titleSectionMarginTop }) => titleSectionMarginTop || 64,
    width: '100%'
  },
  promoTagContainer: {
    display: 'flex',
    marginBottom: 24
  },
  promoTag: {
    backgroundColor: theme.error[0],
    borderRadius: 4,
    display: 'flex'
  },
  freeTagContainer: {
    display: 'flex',
    marginBottom: 24
  },
  freeTag: {
    border: `1px solid ${theme.success[200]}`,
    backgroundColor: theme.neutral[400],
    borderRadius: 4,
    display: 'flex'
  },
  newBadge: {
    width: 65,
    border: `1px solid ${theme.error[200]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    textTransform: 'uppercase'
  }
})
